import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import InputSearch from "../../component/InputSearch";
import CustomIconButton from "../../component/custom-icon-button/CustomIconButton";
import DialogConfirmDelete from "../../component/dialog-confirm-delete/DialogConfirmDelete";
import { TableCustomHeader } from "../../component/table/components/TableCustomHeader";
import { TablePagination } from "../../component/table/components/TablePagination";
import { TableCustom } from "../../component/table/table-custom/TableCustom";
import { DEFAULT_PAGE_INDEX, SELECTION_MODE } from "../../utils/Constant";
import {
  handlePagesChange,
  handleRowsPerPageChange,
  rowsForPage,
} from "../../utils/PageUtils";
import { COLUMNS } from "../constants/Columns";
import ServiceDetailDialog from "./ServiceDetailDialog";
import { CODE, KEY } from '../../utils/Constant';
import { searchDanhSachDichVu, deleteDV } from "../services/services";
import { toast } from "react-toastify";
import { useIntl } from "react-intl";

type Props = {};

const TableService = (props: Props) => {
  const [configTable, setConfigTable] = useState<any>({
    totalPages: 0,
    totalElements: 0,
    numberOfElements: 0,
  });
  const [rowsPerPage, setRowsPerPage] = useState<number>(20);
  const [page, setPage] = useState<number>(DEFAULT_PAGE_INDEX);
  const [openOrganizationDialog, setOpenOrganizationDialog] =
    useState<any>(false);
  const [rowData, setRowData] = useState<any>(null);
  const [rowDataDelete, setRowDataDelete] = useState<any>(null);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [shouldOpenConfirmDeleteDialog, setShouldOpenConfirmDeleteDialog] = useState(false);
  const [tableData, setTableData] = useState<any[]>([]);
  const [searchData, setSearchData] = useState<any>();
  const intl = useIntl();

  useEffect(() => {
    // selectedRow?.length && window.open(`https://medlatec.vn`, "_blank");
  }, [selectedRow]);

  useEffect(() => {
    getTableData();
  }, [page, rowsPerPage]);

  const handleOpenOrganizationDetailDialog = () => {
    setOpenOrganizationDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenOrganizationDialog(false);
    setRowData(null);
    getTableData();
  };

  const getTableData = async () => {
    try {
      const { data } = await searchDanhSachDichVu({
        ...searchData,
        pageIndex: page,
        pageSize: rowsPerPage,
      });

      if (CODE.SUCCESS === data.code) {
        var tableData = data.data.content.map((item: any, index: number) => ({
          ...item,
          stt: (page - 1) * rowsPerPage + index + 1,
        }));
        setTableData(
          tableData
        );
        setConfigTable({
          totalPages: (data.data.pageable.totalElements / data.data.pageable.pageSize).toFixed(),
          totalElements: data?.data?.pageable?.totalElements,
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleDelete = async (id: string) => {
    try {
      const res = await deleteDV(id);

      if (res?.data?.code === CODE.SUCCESS) {
        toast.success(intl.formatMessage({ id: "TOAST.DELETE.SUCCESS" }));
        getTableData();
      } else {
        toast.error(`${res?.data?.message}`);
      }
    } catch (err) {
      toast.error(intl.formatMessage({ id: "TOAST.DELETE.ERROR" }));
    }
  };

  const columnsActions = {
    Header: (props: any) => (
      <TableCustomHeader<any>
        tableProps={props}
        title={"Thao tác"}
        className="text-center text-light spaces W-80"
      />
    ),
    id: "actions",
    Cell: ({ ...props }) => (
      <div className="d-flex justify-content-center gap-3">
        <CustomIconButton
          variant="edit"
          onClick={() => {
            setOpenOrganizationDialog(true);
            setRowData(props.cell.row.original);
          }}
        >
          <i className="bi bi-pencil-square text-navy"></i>
        </CustomIconButton>
        <CustomIconButton
          variant="delete"
          onClick={() => {
            setShouldOpenConfirmDeleteDialog(true);
            setRowDataDelete(props.cell.row.original);
          }}
        >
          <i className="bi bi-trash3-fill text-danger"></i>
        </CustomIconButton>
      </div>
    ),
  };

  return (
    <div className="bg-white">
      <div className="flex-1 flex flex-column">
        <div className="d-flex bg-gray "></div>
        <div className="spaces width-100 bg-gray radius-2">
          <div className="flex bg-white  spaces width-100 justify-content-between">
            <h4 className="text-title text-pri fw-bold fs-4 spaces mb-0  px-10">
              {`Danh sách dịch vụ`}
            </h4>
          </div>
          <div className="d-flex  mt-5 flex-column spaces width-100">
            <div className="bg-white">
              <div className="d-flex spaces px-8 mt-6 bg-white justify-content-between align-items-center mb-6">
                <div className="d-flex">
                  <Button
                    className="btn-fill min-w-50px"
                    onClick={handleOpenOrganizationDetailDialog}
                  >
                    Thêm mới
                  </Button>
                </div>

                <div className="w-25">
                  <InputSearch
                    placeholder="Tìm kiếm"
                    className="spaces h-31 pr-4  radius-3"
                    handleChange={
                      (e) => {
                        setSearchData({
                          ...searchData,
                          keyword: e.target.value,
                        })
                      }
                    }
                    handleKeyDown={
                      (e: React.KeyboardEvent) => {
                        e.key === KEY.ENTER && getTableData()
                      }}
                    handleSearch={() => getTableData()}
                  />
                </div>
              </div>
              <div className=" spaces bg-white mb-0 mt-6">
                <TableCustom<any>
                  className="spaces h-calc-vh-180"
                  data={tableData}
                  columns={COLUMNS}
                  columnsActions={columnsActions}
                  selectionMode={SELECTION_MODE.SINGLE_NO_RADIO_BUTTON}
                  verticalScroll={true}
                  getSelectedRowsData={setSelectedRow}
                />
                <TablePagination
                  handlePagesChange={handlePagesChange}
                  handleRowsPerPageChange={handleRowsPerPageChange}
                  rowsPerPage={rowsPerPage}
                  rowsForPage={rowsForPage}
                  page={page}
                  setPage={setPage}
                  setRowsPerPage={setRowsPerPage}
                  totalPages={Number(configTable.totalPages)}
                  totalElements={configTable.totalElements}
                  numberOfElements={configTable.numberOfElements}
                  className="border border-0"
                />
              </div>
            </div>
          </div>
          <div className="spaces w-100 d-flex justify-content-end bg-white mt-2 gap-6 py-8 z-index-2"></div>
        </div>
      </div>

      {openOrganizationDialog && (
        <ServiceDetailDialog
          handleClose={handleCloseDialog}
          data={rowData}
          handleReload={getTableData}
        />
      )}

      {shouldOpenConfirmDeleteDialog && (
        <DialogConfirmDelete
          dialogDelete={shouldOpenConfirmDeleteDialog}
          setDialogDelete={setShouldOpenConfirmDeleteDialog}
          handleDelete={() => {
            handleDelete(rowDataDelete.id);
            setShouldOpenConfirmDeleteDialog(false);
          }}
        />
      )}
    </div>
  );
};

export default TableService;
